export const locale = {
    default: {
        meta: {
            description: "På Filmweb kan du kjøpe kinobilletter, se trailere, lese filmomtaler, se bilder, delta i konkurranser og lese filmnyheter. Hele Norges filmportal!",
            title: "Filmweb - Filmopplevelsen starter på Filmweb!"
        }
    },
    actions: {
        save: "Lagre",
        cancel: "Avbryt",
        close: "Lukk"
    },
    progress: {
        loading: "Laster..."
    },
    menu: {
        menu: "Meny",
        login: "Logg inn"
    },
    ads: {
        sponsored: "Annonsørinnhold",
        contentAd: "Annonsørinnhold",
        adLabel: "Annonse",
        advertiser: "Annonsør",
        hideAd: "Skjul annonse"
    },
    filmomtale: {
        sg: {
            meta: {
                title: "strømme online - Streamingguide"
            }
        },
        availableOnCinema: "Filmen er tilgjengelig på kino. Klikk her for å se forestillinger",
        availableOnStreaming: "Filmen er tilgjengelig på streaming. Klikk her for å se hvor den kan streames.",
        mediaLabel: "Anmeldelser fra media",
        starRatingLabel: "Anmelder ga {{value}}",
        actorLabel: "Skuespillere",
        voiceActorLabel: "Norske stemmer",
        medvirkendeLabel: "Medvirkende",
        genreLabel: "Sjanger",
		originalTitle: "Originaltittel",
        besetningLabel: "Besetning",
        nasjonalitetLabel: "Nasjonalitet",
        produksjonsårLabel: "Produksjonsår",
        distributørLabel: "Distributør",
        visesILabel: "Vises i",
        språkLabel: "Språk",
        originalSpråk: "Originalspråk",
        actor: "Skuespiller",
        voiceActor: "Norsk stemme",
        orgVoiceActor: "Original stemme",
        director: "Regi",
        script: "Manus",
        versjon: "versjon",
        seeGallery: "Se bildegalleri",
        ageRating: "Aldersgrense",
        ageRatingWithReason: "med begrunnelse",
        ageReasonExpand: "Les mer",
        premiere: "Premiere",
        reRelease: "Premiere (relansering)",
        expectedPremeiere: "Antatt premiere",
        relatedNews: "Relaterte nyheter",
        latestNews: "Relaterte nyheter"
    },
    forside: {
        articlesAndList: {
            follow: "Følg oss"
        },
        topRatedMovieLists: {
            usersHeading: "Brukernes topp 10",
            criticsHeading: "Anmeldernes topp 10"
        }
    },
    navn: {
        noFilmography: "Fant ingen filmografi"
    },
    trailere: {
        meta: {
            title: "Trailere",
            description: "Se de nyeste trailerne for kommende filmer og TV-serier!",
        },
        heading: "Nyeste trailere",
        trailerButtonText: "Trailer"
    },
    articleSummary: {
        label: "Oppsummering av saken",
        showMore: "Vis mer"
    },
    poster: {
        posterMissing: "Plakat mangler",
        posterFor: "Plakat for",
        customInfoLinkText: "Se program og filminfo"
    },
    providers: {
        incinema: "På kino",
        presale: "Forsalg"
    },
    bilde: {
        imageMissing: "Bilde mangler",
        imageGallery: "Bildegalleri"
    },
    watchlist: {
        signInToWatchlist: "Legg filmen/serien i huskelisten",
        addToWatchlist: "Legg filmen/serien i huskelisten",
        filterAll: "Alle titler",
        filterInCinemas: "På kino",
        filterComingToCinemas: "Kommer på kino",
        filterStreaming: "På streaming"
    },
    favourites: {
        callToAction: "Merk filmen/serien som en favoritt"
    },
    program: {
        meta: {
            title: "Kinobilletter og program",
            description: "Her finner du kinoprogrammet og billettkjøp til din kino, samt informasjon om aldersgrense, sjanger, trailer og fakta om filmen.",
            titleLocation: "Kinoprogram for {{location}}",
            titleCinema: "Kinoprogram for {{location}}, {{cinema}}",
            descriptionLocation: "Her er kinoprogrammet og billettkjøp for alle kinoer i {{location}}! Her kan du filtrere etter sted, kino, tidspunkt og sjanger.",
            descriptionCinema: "Her er kinoprogrammet og billettkjøp for alle kinoer i {{location}}, {{cinema}}! Her kan du filtrere etter sted, kino, tidspunkt og sjanger."
        },
        // keys for the program state in the url hash, e.g. #20.10.2026&kino=Kino+A&sjanger=Familiefilm
        hashKeys: {
            cinema: "kino",
            genre: "sjanger"
        },
        // the cinema filter on film pages is only offered (and applied) when one of these is among the selected locations
        cinemaFilterLocations: ["Oslo"],
        pageTitle: "Kinoprogram",
        pageTitleLocation: "Kinoprogram for {{location}}",
        pageTitleCinema: "Kinoprogram for {{cinema}} i {{location}}",
        pageSubtitleLocation: "Her finner du kinoprogram og billetter for alle kinoer i {{location}}!",
        pageSubtitleCinema: "Her finner du kinoprogram og billetter for {{cinema}} i {{location}}!",
        filterMessage: {
            template: "Dine filterinnstillinger skjuler {{numFilteredMovies}} {{optionalShows}}",
            film: "filmer",
            shows: "forestillinger",
            reset: "Nullstill filter"
        },
        noLocation: {
            action: "Klikk for å velge kinosted",
            prompt: "Du må velge kinosted for å se visninger."
        },
        loadError: {
            message: "Vi klarte ikke å hente visningene akkurat nå.",
            retry: "Prøv igjen"
        },
        movie: {
            showMore: "Flere forestillinger",
            showLess: "Færre forestillinger",
            showAll: "Se alle forestillinger",
            readMore: "Les mer"
        },
        noShows: {
            noMoreShowsDefault: "Denne filmen har ingen flere visninger. Legg denne filmen i huskelisten og få påminnelse når den kommer på en strømmetjeneste.",
            expectedPremiere: "\"{{movieTitle}}\" har antatt kinopremiere {{premiere}}. Vil du varsles når billettsalget starter, så kan du legge filmen i huskelisten.",
            expectedPremiereMobile1: "Antatt kinopremiere {{premiere}}",
            expectedPremiereMobile2: "Klikk her for varsling om billettsalg.",
            premierePassed: "\"{{movieTitle}}\" hadde kinopremiere {{premiere}}. Det er ikke satt opp noen forestillinger av filmen akkurat nå.",
            premierePassedMobile1: "Filmen hadde kinopremiere {{premiere}}",
            premierePassedMobile2: "Det er ikke satt opp noen forestillinger av filmen akkurat nå.",
            hasPremiere: "\"{{movieTitle}}\" har kinopremiere {{premiere}}. Vil du varsles når billettsalget starter, så kan du legge filmen i huskelisten.",
            hasPremiereMobile1: "Kinopremiere {{premiere}}",
            hasPremiereMobile2: "Klikk her for varsling om billettsalg.",
            nextShow: "Neste visning for denne filmen er",
            noMoreShowsForLocation: "Ingen forestillinger tilgjengelig for valgt kinosted",
            nextShowday: "Neste dag med film på programmet er",
            noShowsForSelectedCinemas: "Det er ingen forestillinger av filmen på de valgte kinoene.",
            showAllCinemas: "Vis alle kinoer"
        },
        changeLocation: "Endre",
        selectLocation: "Velg sted",
        searchLocations: "Søk sted",
        locationHeading: "Velg ett eller flere steder",
        nearby: "Kinoer i nærheten",
        allCinemas: "Alle kinoer",
        familyMovies: "Familiefilm",
        allDates: "Alle dager",
        moreCinemas: "Velg kinoer"

    },
    kommer: {
        meta: {
            title: "Kommer på kino",
            description: "Full oversikt over alle filmer som får kinopremiere i Norge."
        },
        heading: "Kommende kinofilmer",
        subHeading: null as string | null,
        viewText: "Tekstliste",
        viewPoster: "Posterliste",
        premThisWeekHeading: "Premierer denne uken",
        posterIncoming: "Plakat kommer"

    },
    aktuelle: {
        meta: {
            title: "",
            description: ""
        },
        heading: "",
        subHeading: null as string | null,
        viewText: "",
        viewPoster: "",
        premThisWeekHeading: "",
        posterIncoming: ""
    },
    popularMoviesList: {
        label: "Populære filmer"
    },
    ticketButton: {
        buyTickets: "Kjøp billetter"
    },
    consent: {
        cookiesWait: "Venter på cookies",
        cookiesLabel: "For å se dette innholdet må {{cookiesNeeded}}-cookies være slått på. Klikk her for å endre dine innstillinger.",
        cookieTypeMarketing: "markedsførings",
        cookieTypePreferences: "preferanse",
        cookieTypeStatistics: "statistikk",
        cookieChangeButton: "Endre/trekk tilbake cookiesamtykke"
    },
    kinotoppen: {
        meta: {
            title: "Kinotoppen",
            description: "Se hvilke filmer som topper kinolistene i Norge. Oversikt over helgens mest sette og kinotoppen for i år."
        },
        heading: "Kinotoppen"
    },
    newsletter: {
        callToAction: "Meld deg på vårt nyhetsbrev",
        emailPlaceholder: "Din epostadresse",
        tosError: "Du må godta personvernerklæringen",
        tosAcceptPreamble: "Godta",
        tosLink: "personvernerklæringen"
    },
    user: {
        anonymous: "Anonym bruker",
        deleted: "Slettet bruker"
    },
    review: {
        alreadyReported: "Du har allerede rapportert denne anmeldelsen",
        report: "Rapporter anmeldelsen",
        reportHelperText: "Innrapporterte tekster vil bli vurdert av Filmwebs redaksjon for å se om de bryter med våre retningslinjer.",
        noReviews: "Foreløpig har ingen anmeldt {{title}}",
        heading: "Anmeldelser fra publikum",
        callToAction: "Skriv anmeldelse",
        readMore: "Les mer",
        seeMore: "Se flere",
        removeRatingError: "Kan ikke fjerne vurderingen så lenge det er en anmeldelse",
        validationError: "Vi tillater ikke lenker i tekstene. Fjern lenken og lagre på nytt.",
        validationErrorMaxLength: "Din anmeldelse er for lang! Maks {{MAX_REVIEW_LENGTH}} tegn",
        ratingRequired: "Du må gi en vurdering!",
        placeholder: "Skriv din anmeldelse...",
        seeReviews: "Se anmeldelser",
        removeReview: "Fjern anmeldelse",
        likeReview: "Gi denne anmeldelsen en like!",
        reviewRestoredFromDraft: "En ulagret kladd ble gjenopprettet.",
        saveError: "Anmeldelsen kunne ikke lagres. Prøv igjen."
    },
    ratings: {
        headingCta: "Gi din vurdering:",
        headingAvg: "Gjennomsnitt av vurderinger:",
        ratingCount: "Så langt har {{ratingCount}} gitt vurdering",
        ratingAverage: "Snitt {{ratingAverage}} basert på {{ratingCount}} vurderinger",
        yourRating: "Din vurdering:",
        noRating: "Så langt har ingen gitt vurdering.",
        ratingButtonLabel: "Gi filmen/serien {{RATING_VALUE}} {{RATING_VALUE_UNIT}}",
        ratingUnitSingular: "stjerne",
        ratingUnitPlural: "stjerner",
        callToAction: "Gi filmen/serien din vurdering"
    },
    favorite: {
        callToAction: "Merk filmen/serien som en favoritt"
    },
    footer: {
        someHeader: "Følg oss",
        ourTerms: "Våre brukervilkår",
        cookieUsage: "Filmweb.no bruker"
    },
    biograf: {
        transportHeading: "Transport og parkering",
        openingTimesHeading: "Åpningstider",
        contactHeading: "Kontakt og veibeskrivelse"

    },
    filmnytt: {
        bottomSoMeHeader: "Følg oss for siste nytt, konkurranser og film og serietips:",
        mostRead: "Meste leste nyheter",
        relatedNews: "Relaterte nyheter",
        byline: {
            redaksjonen: "Redaksjonen",
            published: "Publisert",
            lastUpdated: "Sist oppdatert",
            followUs: "Følg oss"
        },
        section: {
            meta: {
                title: "Filmnyheter"
            }
        }
    },
    minside: {
        menu: {
            watchlist: "Min huskeliste",
            favorites: "Min favoritter",
            ratings: "Mine vurderinger",
            reviews: "Mine anmeldelser",
            orders: "Mine bestillinger",
            settings: "Profil- og varslingsinnstillinger",
            logout: "Logg ut"
        },
        myWatchlist: "Huskeliste",
        myWatchlistEmpty: "Du har ikke lagt til noe i din huskeliste",
        myWatchlistFilterNoResults: "Ditt filter ga ingen resultater",
        myRatings: "Mine vurderinger",
        myRatingsEmpty: "Du har ikke vurdert noen filmer/serier",
        myReviews: "Mine anmeldelser",
        myReviewsEmpty: "Du har ikke skrevet noen anmeldelser",
        myFavourites: "Favoritter",
        myFavouritesEmpty: "Du har ikke merket noen serier eller filmer som favoritter",
        settings: {
            pageTitle: "Profil- og varslingsinnstillinger",
            alertLabel: "Varslingsinnstillinger for e-post",
            alertDescription: "Vi varsler når filmer og serier som ligger i huskelisten settes opp på kino eller strømmetjenester. Du kan velge hvilke situasjoner som skal gi et varsel på e-post.",
            manageAccountButtonLabel: "Administrer visningsnavn, epost-adresse og påloggingsmetoder på mitt Filmweb ID-konto",
            alerts: {
                cinemaPreferred: "Jeg vil motta en e-post når en film settes opp på min kino",
                cinemaNational: "Jeg vil motta en e-post når en film har nasjonal premiere, selv om den ikke er satt opp på min kino",
                streamingAnyService: "Jeg vil motta en e-post første gang en tittel dukker opp i en streamingtjeneste",
                streamingSubscriptionService: "Jeg vil motta en e-post når en tittel dukker opp på en abonnementstjeneste",
                myCinemaExplanation: "\"Min kino\"er den kinoen du har valgt i Filmwebs kinoprogram til enhver tid",
                streamingSubscriptionServicesExplanation: "Abonnementstjenestene vi varsler er Netflix, Disney+, HBO, Amazon Prime, AppleTV+, Paramount+, NRK, TV2 Play, Discovery+"
            },

        },
        orders: {
            pageTitle: "Mine billetter",
            noOrders: "Du har ingen kjøpshistorikk ennå",
            unknownFilm: "Ukjent film",
            bought: "Kjøpt:",
            showDetails: "Vis detaljer",
            hideDetails: "Skjul detaljer",
            orderId: "Ordre",
            ticketCount: "Antall billetter:",
            ticketCountUnit: "billett(er)",
            seeTickets: "Se billetter",
            receipt: "Kvittering",
            previousPage: "Forrige",
            nextPage: "Neste",
            showQrCodes: "Vis QR-koder",
            hideQrCodes: "Skjul QR-koder"
        },
        selfDeleter: {
            deleteButtonLabel: "Slett min bruker",
            confirmYes: "Ja, jeg er helt sikker",
            confirmNo: "Nei, jeg har ombestemt meg!"
        },
        pictureUploader: {
            uploadInfo: "For best resultat så bør bildet være større enn 100 x 100 pixler",
            errors: {
                tooLarge: "Filen er for stor! Bildet må være mindre enn 20MB.",
                fileType: "Bildetypen er ikke støttet! Bilden må være av typen jpeg, png, webp eller gif",
                generic: "Det oppstod en feil under opplasting av bildet.",
                tooSmall: "Bildet er for lite! Bildet må være minst 100 x 100 pixler"
            },
            callToAction: "Last opp profilbilde",
            uploadNewButtonLabel: "Last opp profilbilde",
        }
    },
    kinoklubb: {
        posterbanner: "Halv pris med Kinoklubben",
        showsbanner: "* Halv pris på [https://www.kinoklubb.no/|Kinoklubb-forestillinger]"
    },
    error: {
        notfound: {
            title: "404-ARRR!",
            subheading: "Splitte mine bramseil!",
            body: "Vi har lett og lett over de syv hav, men finner dessverre ikke siden du er ute etter. Kanskje skyldes dette at siden du leter etter ikke finnes eller at du ble gitt feil adresse. Eller kanskje har noen landkrabber begravd den?",
            listHeading: "Vi anbefaler deg å prøve en av følgende:",
            listItems: [
                "Filmwebs [/|forside]",
                "[/program|Kinoprogrammet]",
                "[/streamingguide|Streamingguiden]",
                "Bruk søkefeltet i menyen"
            ],
            postheading: "Fortsatt usikker eller har du forslag til noe som burde vært endret? Send oss gjerne en e‑post til [mailto:kundeservice@filmweb.no|kundeservice@filmweb.no]."
        }
    },
    search: {
        action: "Søk",
        prompt: "Skriv inn søk",
        results: "Søkeresultat",
        noresults: "Ingen treff",
        placeholder: "Søk etter film eller serie",
        seeMore: "Se flere treff",
        locationResultHeading: "Treff på kinosteder"
    },
    biografi: {
        actor: "Medvirker",
        director: "Regissør",
        voice: "Stemmer"
    },
    componentFilmwebNews: {
        header: "Nyheter"
    },
    dateSelector: {
        previousMonth: "Forrige måned",
        nextMonth: "Neste måned"
    }
} as const;